<template>
  <div class="mt-2 ml-2 pt-1 pb-2 px-1 blue-grey lighten-5 inner-attributes">
    <div class="text-subtitle-1 ml-2 mb-0 mt-1">
      {{ title }}
    </div>

    <location-attribute-switch-simple
      class="ml-2"
      v-for="item in items"
      :key="item.display_name"
      :text="item.display_name"
      :value="item.value"
      :checked="myValue === item.value"
      v-on:change="val => updateData(val, item.value)"
    />
  </div>
</template>

<script>
import LocationAttributeSwitchSimple from '@/views/Locations/Components/LocationAttributeSwitchSimple'
import _ from 'lodash'

export default {
  name: "LocationAttributeSelect",
  props: {
    title: {
      type: String,
      required: true
    },
    items: Array,
    value: String
  },
  computed: {
    _() {
      return _
    }
  },
  components: {
    LocationAttributeSwitchSimple
  },
  data: () => ({
    myValue: null,
  }),
  created() {
    this.myValue = this.value
  },
  methods: {
    updateData: function(value, name) {
      this.myValue = value ? name : null
      this.change()
    },
    change: function() {
      this.$emit('change', this.myValue)
    },
  }
}
</script>

<style scoped>
.inner-attributes {
  border-radius: 10px;
}
</style>